import { BandageIcon } from './BandageIcon';

/**
 * author: Google
 * id 6CDF527A-26C1-4175-A56B-5D65FD5E46E2
 * name bandage
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bandage.svg
 * tags
 */
export const PlasterIcon = BandageIcon;
export default PlasterIcon